module.exports = __webpack_public_path__ + "img/interation.0bbf1e65.svg";